import Modal from "react-modal";
import React, { useLayoutEffect, useState } from "react";
import { useAuthDispatch } from "../../Context/auth-context";
import { actionTypes } from "../../Context/reducer";
import axios from "axios";
import { formatText } from "../RulesAndRegulations";

export default function ({ modalIsOpen, Openchanger }) {
  const dispatch = useAuthDispatch();
  const [text, setText] = useState("");
  useLayoutEffect(() => {
    dispatch({
      type: actionTypes.LOGIN_REQUEST,
    });

    axios
      .get("https://api.sinatether.com/Auth/getExampleText/", {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status == 200) {
          setText(res.data.text);
        }
      })
      .catch((error) => {
        if (error) {
          dispatch({
            type: actionTypes.LOGOUT,
          });
        }
      });
  }, []);

  const customStyles = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "white",
      width: "33rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(91vh - 2rem)",
      overflowY: "auto", // Enable vertical scrolling if content exceeds maxHeight
      position: "relative",
      border: "0px",
      borderRadius: "0.3rem",
      inset: "0px",
      padding: "1rem", // Optional: Add some padding for better spacing
    },
  };

  Modal.setAppElement("#root");

  let subtitle;
  function afterOpenModal() {}
  function closeModal() {
    Openchanger(false);
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      ariaHideApp={false}
      style={customStyles}
      contentLabel="Example Modal"
      backdrop="static"
    >
      <div className={"container"} id={"mbody"}>
        <div className={"title"}>
          <span className="close" onClick={closeModal}>
            &times;
          </span>
          <h6>نمونه عکس ارسالی</h6>

          <hr />
        </div>
        <div className={"text-warning text-large"}>
          <p className={"text-danger"}>توجه :</p>
          <p className={"text-danger"}>
            عکس ارسالی باید بدون عینک توسط شخص دیگر برای عدم برعکس افتادن نوشته
            گرفته شود.
          </p>
        </div>

        <div>
          <div className={"txp  pb-2"}>
            <p className={"text-info text-large"}>متن ارسالی :</p>
            <p
              className={"border-success border-5 text-large"}
              dangerouslySetInnerHTML={{ __html: formatText(text) }}
            />
          </div>
        </div>

        <div className={"text-center align-items-center"}>
          <img src={"images/selfiexample.png"} className={"w-75 h-75"} />
        </div>
      </div>
    </Modal>
  );
}
